import * as React from "react";
import {type Theme, type Components} from "../..";

type AccordionDetailsOverrides = Components<Theme>["MuiAccordionDetails"];

const overrides: AccordionDetailsOverrides = {
    styleOverrides: {
        root: ({theme}) => ({
            padding: "0px 16px 24px",
            color: theme.color.text.subtle,
        }),
    },
};

export default overrides;
